import * as core from '../../../../../../../core'
import * as spaceSurveyStatus from '../space-survey-func-method'

export const RESOURCE = {
  payload: {
    description: 'Joint Use',
    enumId: core.dms.models.Enum.Id.from({
      partialId: spaceSurveyStatus.RESOURCE.payload.partialId,
    }),
    id: 'JOINT_USE',
    name: 'Joint Use',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
